import React, { useMemo } from 'react'
import { selectPaymentFees, selectSelectedPaymentMethod } from '../../../../store/slices/payment/paymentSelectors';
import { Grid, Row, Col, Text } from 'rsuite';
import { useSelector } from 'react-redux';
import { convertNumberToCurrency } from '../../../../common/utils';
import { calculateProcessingFee, getProcessingFeeLabel, calculateTotalDue } from '../utils';

const PaymentSummary = () => {
    const paymentFees = useSelector(selectPaymentFees);
    const selectedPaymentMethod = useSelector(selectSelectedPaymentMethod);

    const totalDue = useMemo(() => calculateTotalDue(selectedPaymentMethod, paymentFees), [selectedPaymentMethod, paymentFees]);
    
    const processingFee = useMemo(() => calculateProcessingFee(selectedPaymentMethod, paymentFees), [selectedPaymentMethod, paymentFees]);

    const processingFeeLabel = useMemo(() => getProcessingFeeLabel(selectedPaymentMethod), [selectedPaymentMethod]);

    return (
        <Grid fluid>
            <Row>
                <Col xs={12} lg={24} className='mb-16'>
                    <Text className='mb-8'>Total Amount Due</Text>
                    <Text className='header-text-h3 text-bold'>{convertNumberToCurrency(totalDue)}</Text>
                </Col>
                <Col xs={12} lg={24}>
                    <div role="grid">
                        {
                            paymentFees.breakdown.map((item, index) => (
                                <Row key={index} className='mb-8'>
                                    <Col xs={24}>
                                        <Text className='text-small'>{item.label}</Text>
                                        <Text>{convertNumberToCurrency(item.value)}</Text>
                                    </Col>
                                </Row>
                            ))
                        }
                        <Row>
                            <Col xs={24}>
                                <Text className='text-small'>{processingFeeLabel}</Text>
                                <Text>{convertNumberToCurrency(processingFee)}</Text>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </Grid>
    );
}

export default PaymentSummary
